(function($, undefined) {
	'use strict';
	var directoryScrollCtn;
	var directoryInnerScrollCtn;
	var directoryProfilesSectionCtn;
	var directoryLettersCtn;
	var directoryScrollLetterBtn;
	var tapHoldLetterDisplayCtn;
	var reverseScroll = false;
	var letterPositionsArrayOri = [];
	var letterPositionsArray;

	var getFirstDisplayedLetter = function() {
		var firstDisplayedLetter = directoryProfilesSectionCtn.first().attr('data-letter');
		$('.directory-scroll-letter-btn[data-letter="' + firstDisplayedLetter + '"]').addClass('selected');
	};

	var scrollToLetterSection = function(t, isTapHold) {
		var chosenLetter = t.attr('data-letter');
		var chosenLetterProfilesSection = $('.directory-profiles-inner-ctn[data-letter="' + chosenLetter + '"]');
		var ctnPosition;
		var speed;

		if (isTapHold === true) {
			speed = 50;
		} else {
			speed = 300;
		}

		if (chosenLetterProfilesSection.length === 0) {
			// if there is no profile for the chosen section, try the next letter. 
			// If it's the last letter and there are still no sections found, start scrolling backwards
			if (isTapHold !== true) {			
				if (t.is(':last-child') || reverseScroll === true) {
					reverseScroll = true;
					t.prev().trigger('click');
				} else {
					t.next().trigger('click');
				}
			}
		} else {
			reverseScroll = false;
			changeSelectedLetterBtn(t);

			if (directoryInnerScrollCtn.position().top < 0) {
				ctnPosition = -(directoryInnerScrollCtn.position().top);
			} else {
				ctnPosition = directoryInnerScrollCtn.position().top;
			}

			directoryScrollCtn.animate({
				scrollTop: ctnPosition + chosenLetterProfilesSection.position().top
			}, speed);
		}
	};

	var changeSelectedLetterBtn = function(letter) {
		$('.directory-scroll-letter-btn.selected').removeClass('selected');
		letter.addClass('selected');
	};

	// TOUCH
	var getClosestHeldLetter = function(offsetY) {
		letterPositionsArray = letterPositionsArrayOri.slice(); 
		letterPositionsArray.sort(function(a, b) {
		    return Math.abs(offsetY - a) - Math.abs(offsetY - b);
		});

		var currentHeldLetterPosition = letterPositionsArray[0];
		var letterIndex = letterPositionsArrayOri.indexOf(currentHeldLetterPosition);
		var letterBtnSelector = $('.directory-scroll-letter-btn[data-tab=' + (letterIndex + 1) + ']');

		changeSelectedLetterBtn(letterBtnSelector);
		scrollToLetterSection(letterBtnSelector, true);
		changeTapHoldLetterDisplay(letterBtnSelector.attr('data-letter'), offsetY);
	};

	var changeTapHoldLetterDisplay = function(letter, offsetY) {
		if (!tapHoldLetterDisplayCtn.hasClass('active')) {
			tapHoldLetterDisplayCtn.addClass('active');
		}

		var halfLetterBtnHeight = directoryScrollLetterBtn.height() / 2;
		var y;

		if (offsetY > (directoryLettersCtn.height() - directoryScrollLetterBtn.height())) {
			y = directoryLettersCtn.height() - directoryScrollLetterBtn.height() - halfLetterBtnHeight;
		} else if (offsetY < 0) {
			y = -halfLetterBtnHeight;
		} else {
			y = offsetY - halfLetterBtnHeight;
		}

		tapHoldLetterDisplayCtn.css('top', y + 'px');
		tapHoldLetterDisplayCtn.find('.letter').html(letter);
	};

	var init = function (page) {
		loadTouchEvents($);

		directoryScrollCtn = $('.directory-profiles-outer-ctn.responsive');
		directoryInnerScrollCtn = $('.directory-inner-scroll');
		directoryProfilesSectionCtn = $('.directory-profiles-inner-ctn', directoryScrollCtn);
		directoryLettersCtn = $('.directory-alphabet-outer-ctn.responsive .directory-alphabet-inner-ctn');
		directoryScrollLetterBtn = $('.directory-scroll-letter-btn');
		tapHoldLetterDisplayCtn = $('.directory-alphabet-tap-hold-mobile-ctn', directoryLettersCtn);

		directoryScrollLetterBtn.click(function() {
			scrollToLetterSection($(this));
		});

		// TOUCH PHONE CONTACTS EFFECT
		// https://www.npmjs.com/package/jquery-touch-events
		directoryScrollLetterBtn.on('tapstart', function(e) {
			$('body, html').addClass('no-scroll');
		});

		directoryScrollLetterBtn.on('tapend', function(e) {
			$('body, html').removeClass('no-scroll');
			tapHoldLetterDisplayCtn.removeClass('active');
		});

		directoryScrollLetterBtn.each(function() {
			letterPositionsArrayOri.push($(this).position().top);
		});

		directoryLettersCtn.on('tapmove', function(e, touch) {
			if (touch.offset.x >= 0) {
				getClosestHeldLetter(touch.offset.y);
			}
		});

		getFirstDisplayedLetter();
	};

	$(window).on("load",function(){
		init();
	});
	
})(jQuery);